import {
    DELETED_COMPANIES_REQUEST,
    DELETED_COMPANIES_SUCCESS,
    DELETED_COMPANIES_FAIL, SINGLE_COMPANIES_SUCCESS, UPDATE_COMPANIES_SUCCESS,
} from '../actions/companies.js';


const initialState = {
    companyStatus: 'request',
    company: {},
    notification:0,
    single: {}

};
// eslint-disable-next-line default-param-last
export default function reducer(state = initialState, action) {
    switch (action.type) {
        case DELETED_COMPANIES_REQUEST: {
            return {
                ...state,
                companyStatus: 'request',
            };
        }
        case DELETED_COMPANIES_SUCCESS: {
            return {
                ...state,
                companyStatus: 'ok',
                company:action.payload.data
            };
        }
        case UPDATE_COMPANIES_SUCCESS:
        case SINGLE_COMPANIES_SUCCESS: {
            return {
                ...state,
                companyStatus: 'ok',
                single:action.payload.data
            };
        }
        case DELETED_COMPANIES_FAIL: {
            return {
                ...state,
                companyStatus: 'fail',
            };
        }



        default: {
            return {
                ...state,
            };
        }
    }
}
